import $ from 'jquery';
export default class FloatingMessage {
    static init($root = $('body')) {
        const $message = $root.find('.js__floating-message');
        if (!$message.length) {
            return;
        }
        $message.each((index, element) => {
            const $element = $(element);
            const $messageClose = $element.find('.js__floating-message-close');
            $messageClose.on('click', () => {
                $element.addClass('d-none');
            });
        });
    }
}
